import { render, staticRenderFns } from "./OrderUpdatePaymentCustomer.vue?vue&type=template&id=478933f2"
import script from "./OrderUpdatePaymentCustomer.vue?vue&type=script&lang=js"
export * from "./OrderUpdatePaymentCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports